import axios, { AxiosResponse } from "axios";
import TitleValue from "../../models/dtos/base/TitleValue";
import BaseService from "../base/BaseService";

export default class StudentBaseService extends BaseService {
    getBaseTitleValueByStudentId(): Promise<TitleValue<number>[]> {
        return axios.get( '/StudentBases/GetBaseTitleValueByStudentId')
            .then(function (response: AxiosResponse<TitleValue<number>[], any>) {
                return response.data;
            });
    }

    getTitleValues(): Promise<TitleValue<number>[]> {
        return axios.get( '/StudentBases/TitleValues')
            .then(function (response: AxiosResponse<TitleValue<number>[], any>) {
                return response.data;
            });
    }
}